import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// stuff for dialog - move if separating
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';

import PaginatedTable from 'app/components/tables/PaginatedTable';
import EditEntryDialog from 'app/components/form/EditEntryDialog';
import FormImportDialog from 'app/components/form/FormImportDialog';

import useApp from 'app/context/useApp';

import tableFieldTypes from 'app/utils/TableFieldTypes';

const useFilterStyles = makeStyles(theme => ({
    subSection: {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.grey[200]
    },
    subSectionLoading: {
        textAlign: 'center',
        padding: theme.spacing(3),
        backgroundColor: theme.palette.grey[200]
    },
    dialogSpacing: {
        padding: theme.spacing(1)
    },
    noSpacing: {
        padding: 0
    },
    noMarginLeft: {
        marginLeft: 0
    },
    empty: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    noContentPadding: {
        padding: 0
    }
}));

const FilterEntriesDialog = (props) => {

    const classes = useFilterStyles()

    const { open, onClose, onFilter } = props;

    const [ filters, setFilters ] = useState([]);
    const [ statusChecked, setStatusChecked ] = useState([]);

    const { app } = useApp();

    // Get Functions ------------------------------------------

    const getFilters = () => {
        const newFilters = app.user.application_state.entries.filters;
        const activeFilters = [];

        if (newFilters.status && newFilters.status instanceof Array && newFilters.status.length > 0) {
            setStatusChecked(newFilters.status);
            activeFilters.push('status')
        }

        setFilters(activeFilters);
    }

    useEffect(() => {
        getFilters();
    }, []);

    // Handlers ------------------------------------

    const handleFilter = filter => {
        const newFilters = [...filters];
        const i = newFilters.indexOf(filter)

        if (i > -1) {
            newFilters.splice(i, 1)
        } else {
            newFilters.push(filter)
        }

        setFilters(newFilters);
    }

    const handleStatus = id => {
        const newChecked = [...statusChecked]
        const i = newChecked.indexOf(id)

        if (i > -1) {
            newChecked.splice(i, 1)
        } else {
            newChecked.push(id)
        }

        setStatusChecked(newChecked);
    }

    const handleClose = () => {
        onClose();
    }

    // Posters -----------------------------

    const postFilter = () => {

        const data = {}

        if (filters.indexOf('status') > -1 && statusChecked.length > 0) {
            data.status = statusChecked;
        }

        onFilter(data);
        onClose();
    }

    const postClear = () => {
        setStatusChecked([]);
        setFilters([]);
        onFilter({});
        onClose();
    }

    return (
        <Dialog
            maxWidth="xs"
            open={open}
            onClose={handleClose}
            fullWidth
            aria-labelledby="filter-entries"
            >
            <DialogTitle className={classes.dialogSpacing}>
                <Grid container alignItems="center" justify="space-between">
                    <Grid item>
                        <Button color="primary" onClick={postClear} variant="outlined">
                            Clear
                        </Button>
                    </Grid>
                    <Grid item>
                        Filters
                    </Grid>
                    <Grid item>
                        <Button color="primary" variant="contained" onClick={postFilter}>
                            Filter
                        </Button>
                    </Grid>
                </Grid>
            </DialogTitle>
            <Divider />
            <DialogContent className={classes.noContentPadding}>
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={filters.indexOf('status') > -1}
                            onChange={() => handleFilter('status')}
                            name="status"
                            color="primary"
                        />
                    }
                    label="Status"
                />
                <Divider />
                <Collapse in={filters.indexOf('status') > -1}>
                    <FormGroup className={classes.subSection}>
                        {statuses.map(status => (
                            <FormControlLabel
                                className={classes.noMarginLeft}
                                key={status.id}
                                control={
                                    <Checkbox
                                        checked={(statusChecked.indexOf(status.id) > -1)}
                                        onChange={() => handleStatus(status.id)}
                                        name={status}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={window.ucFirst(status)}
                            />
                        ))}
                    </FormGroup>
                </Collapse>
            </DialogContent>
        </Dialog>
    )
}

export default function Entries(props) {

    const {
        formID,
        form,
        getForm,
    } = props;

    const [ columns, setColumns ] = useState([]);
    const [ viewableColumns, setViewableColumns ] = useState([]);
    const [ orderBy, setOrderBy ] = useState('created_at');
    const [ order, setOrder ] = useState('desc');
    const [ importDialogOpen, setImportDialogOpen ] = useState(false);

    useEffect(() => {

        const cols = [
            { id: 'id', align: 'left', disablePadding: false, label: 'ID' },
            { id: 'title', align: 'left', disablePadding: false, label: 'Title' },
            { id: 'subtitle', align: 'left', disablePadding: false, label: 'Subtitle' },
        ];
        const viewableCols = [];
        let oBy = null;
        let oDir = null;

        form.fields.forEach(f => {

            if (tableFieldTypes.indexOf(f.options.type) > -1) {

                if (f.options?.table) {
                    viewableCols.push(f.id.toString())

                    if (f.options?.order_by) {
                        oBy = f.id.toString()
                        oDir = f.options.order
                    }
                }

                cols.push({
                    id: f.id.toString(),
                    label: f.options.label,
                    align: (f.options.type === 'number' || f.options.type === 'currency') ? 'right' : 'left',
                    disablePadding: false,
                    type: f.options.type,
                    is_value: true,
                    format: f.options.format
                })
            }
        })

        viewableCols.push('created_at')
        cols.push(...[
            {id: 'user', align: 'left', disablePadding: false, label: 'Owner'},
            {id: 'user_address', align: 'left', disablePadding: false, label: 'Owner Address'},
            {
                id: 'created_at',
                align: 'left',
                disablePadding: false,
                label: 'Date Created',
                type: 'date',
                format: 'D'
            },
            {
                id: 'read_at',
                type: 'notify',
            }
        ]);

        setColumns(cols);
        setViewableColumns(viewableCols);
        setOrderBy(oBy);
        setOrder(oDir);

    }, [form]);

    // Importing
    const handleImportOpen = () => {
        setImportDialogOpen(true);
    }

    const handleImportClose = () => {
        setImportDialogOpen(false);
    }

    return (columns.length > 1 ) ? (
        <div>
            <PaginatedTable
                columns={columns}
                stateKey="entries"
                label="Entries"
                tableUrl={`/form/${formID}`}
                baseUrl='/admin/form/entry'
                NewDialog={<EditEntryDialog form={form} id={0} admin/>}
                EditDialog={<EditEntryDialog form={form} admin/>}
                initViewableColumns={viewableColumns}
                initOrderBy={orderBy}
                initOrder={order}
                exportTitle={`${form.name} Export`}
                exportAllTitle={`${form.name} Export`}
                onImport={handleImportOpen}
            />
            <FormImportDialog open={importDialogOpen} onClose={handleImportClose} formID={formID}/>
        </div>
    ) : null;
}
